<template>
  <div class="linkListFilterPanel">
    <div class="commandDeck">
      <div class="commandDeck__zone commandDeck__zone--filters">
        <div class="filterDeckHeader">
          <div class="filterDeckHeader__leading">
            <span class="zoneHeader__title">筛选条件</span>
            <div v-if="activeFilterCount" class="filterChips">
              <span class="filterChip">已筛选 {{ activeFilterCount }} 项</span>
              <button
                type="button"
                class="filterChip filterChip--clear"
                @click="$emit('reset-and-search')"
              >
                清除
              </button>
            </div>
          </div>
          <div class="actionBar">
            <el-button
              class="actionButton actionButtonQuery"
              type="primary"
              size="small"
              icon="el-icon-search"
              @click="$emit('search')"
            >
              查询
            </el-button>
            <el-button
              class="actionButton actionButtonOutline"
              size="small"
              icon="el-icon-plus"
              v-check-role
              @click="$emit('go-create')"
            >
              新增设计师
            </el-button>
            <el-button
              class="actionButton actionButtonGhost actionButton--reset"
              size="small"
              icon="el-icon-refresh-left"
              @click="$emit('reset-filters')"
            >
              重置
            </el-button>
          </div>
        </div>
        <div class="filterGrid filterGrid--two">
          <div class="filterItem">
            <span class="searchText">设计师名称</span>
            <el-input
              class="filterControl"
              placeholder="请输入设计师名称"
              prefix-icon="el-icon-search"
              :value="name"
              size="small"
              clearable
              @input="$emit('update:name', $event)"
              @keydown.enter.native="$emit('search')"
            />
          </div>
          <div class="filterItem">
            <span class="searchText">设计师标签</span>
            <el-input
              class="filterControl"
              placeholder="请输入标签"
              :value="tags"
              size="small"
              clearable
              @input="$emit('update:tags', $event)"
              @keydown.enter.native="$emit('search')"
            />
          </div>
          <div class="filterItem">
            <span class="searchText">设计师简介</span>
            <el-input
              class="filterControl"
              placeholder="请输入简介"
              :value="introduction"
              size="small"
              clearable
              @input="$emit('update:introduction', $event)"
              @keydown.enter.native="$emit('search')"
            />
          </div>
          <div class="filterItem">
            <span class="searchText">设计师类型</span>
            <el-select
              class="filterControl"
              popper-class="linkListFilterDropdown"
              :value="type"
              placeholder="请选择设计师类型"
              size="small"
              clearable
              @change="$emit('update:type', $event)"
            >
              <el-option
                v-for="item in typeOptions"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </div>
          <div class="filterItem">
            <span class="searchText">状态</span>
            <el-select
              class="filterControl"
              popper-class="linkListFilterDropdown"
              :value="status"
              placeholder="请选择状态"
              size="small"
              clearable
              @change="$emit('update:status', $event)"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
          <div class="filterItem">
            <span class="searchText">认证状态</span>
            <el-select
              class="filterControl"
              popper-class="linkListFilterDropdown"
              :value="isAuth"
              placeholder="请选择认证状态"
              size="small"
              clearable
              @change="$emit('update:isAuth', $event)"
            >
              <el-option
                v-for="item in authOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showPanelSummary" class="filterPanelSummary">
      <span class="filterPanelSummary__label">共</span>
      <strong class="filterPanelSummary__count">{{ panelTotalCount }}</strong>
      <span class="filterPanelSummary__label">条</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DesignerListFilterPanel',
  props: {
    name: { type: String, default: '' },
    tags: { type: String, default: '' },
    introduction: { type: String, default: '' },
    type: { type: String, default: '' },
    status: { type: [String, Number], default: '' },
    isAuth: { type: [String, Number], default: '' },
    activeFilterCount: { type: Number, default: 0 },
    typeOptions: { type: Array, default: () => [] },
    statusOptions: { type: Array, default: () => [] },
    authOptions: { type: Array, default: () => [] },
    panelTotalCount: { type: Number, default: 0 },
    showPanelSummary: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
@import '../../resourceManage/genericResourceManage/linkListTheme.css';
@import '../../resourceManage/genericResourceManage/linkListFilterPanel.css';
@import '../../resourceManage/genericResourceManage/linkActionButtons.css';

.linkListFilterPanel {
  padding: 0;
  background: transparent;
}

.filterItem {
  grid-template-columns: 88px minmax(0, 1fr);
}

.filterPanelSummary {
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid var(--link-line, #eee9e2);
}

.filterPanelSummary__label {
  color: var(--link-ink-secondary);
}

.filterPanelSummary__count {
  color: var(--link-accent);
  font-weight: 600;
}
</style>
